export default {
  workPlace(state) {
    return state.workPlace
  },
  workPlaces(state) {
    return state.workPlaces
  },
  unitWorkPlaces(state) {
    return state.unitWorkPlace
  },
  workPlaceServiceCategories(state) {
    return state.workPlaceServiceCategories
  },
  isLoadingWorkPlaceServiceCategories(state) {
    return state.isLoadingWorkPlaceServiceCategories
  },
}
